// extracted by mini-css-extract-plugin
module.exports = {"styled-document":"documents_styled-document__SrbiT"};